import React from 'react'
import { Col, Row } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { Input } from 'src/components/Formik'
import { Title } from 'src/components/Ant'

import { InitialValues } from '../initial-values'

interface Props {
  formikProps: FormikProps<InitialValues>
}
export default function UserContacts({ formikProps }: Props) {
  const { t } = useTranslation()
  return (
    <>
      <Title level={4}>{t('web.user.common.contact_data')}</Title>
      <Row gutter={24}>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.phone_number.title"
            name="phoneContact.phone_contacts.0.phone_number"
            required={false}
          />
        </Col>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.mobile_phone_number.title"
            name="phoneContact.phone_contacts.1.phone_number"
            required={false}
          />
        </Col>
        <Col span={8}>
          <Input
            formikProps={formikProps}
            label="web.user.common.email.title"
            name="emailContact.email_contacts.0.email"
            required={false}
          />
        </Col>
      </Row>
    </>
  )
}
